<div class="d-flex justify-content-center align-items-center" style="width: 100%; height: 100%">
  <h1>Redirecting to your billing portal...</h1>
</div>
